import { mediaMax } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { ZIndex } from "config/zIndex";
import styled from "styled-components";

export const Panel = styled.aside`
  background: ${ColorV2.White};
  border: 1px solid ${ColorV2.Blue6};
  border-radius: 0 20px 20px 0;
  box-shadow: 0 12px 32px rgba(15, 42, 64, 0.16);
  left: 0;
  max-width: calc(100vw - 32px);
  padding: 28px;
  position: fixed;
  top: 62%;
  transform: translateY(-50%);
  width: 360px;
  z-index: ${ZIndex.dropdown};

  ${mediaMax.mobileLarge} {
    padding: 24px;
  }
`;

export const MinimizeButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 16px;
  top: 16px;
  width: 32px;

  &:hover {
    background: ${ColorV2.Blue7};
  }
`;

export const Title = styled.h2`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
  margin: 0 36px 8px 0;
`;

export const Description = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue3};
  margin: 0 0 8px;
`;

export const ContactDescription = styled(Description)`
  margin: 0 0 20px;
`;

export const ContactButton = styled.a`
  ${TypographyV2.b1}
  align-items: center;
  background: ${ColorV2.SimflexityGreen};
  border-radius: 999px;
  color: ${ColorV2.White};
  display: inline-flex;
  justify-content: center;
  min-height: 48px;
  padding: 0 24px;
  text-decoration: none;

  &:hover {
    filter: brightness(0.92);
  }
`;

export const CollapsedButton = styled.button`
  ${TypographyV2.b1}
  background: ${ColorV2.SimflexityGreen};
  border: 0;
  border-radius: 0 16px 16px 0;
  box-shadow: 0 6px 20px rgba(15, 42, 64, 0.2);
  color: ${ColorV2.White};
  cursor: pointer;
  left: 0;
  min-width: 56px;
  padding: 24px 0;
  position: fixed;
  top: 68%;
  transform: translateY(-50%);
  z-index: ${ZIndex.dropdown};

  &:hover {
    filter: brightness(0.92);
  }
`;

export const CollapsedLabel = styled.span`
  display: inline-block;
  text-orientation: mixed;
  transform: rotate(180deg);
  writing-mode: vertical-rl;
`;
